import React from 'react';
import { Box, Flex, HStack, Spinner, Text } from '@chakra-ui/react';
import { localise } from '../../../services/lang/lang';
import Chevron, { ChevronDirection } from '../../icons/Chevron';
import { useTokens } from '../../../context/TokenProvider';
import { RenderIf } from '../RenderIf/RenderIf';
const Pagination = ({ meta, isFetching = false, }) => {
    const tokens = useTokens();
    const styles = {
        container: {
            justifyContent: 'right',
            width: '100%',
            background: tokens.Layer01,
            paddingLeft: tokens.Spacing06,
            paddingRight: tokens.Spacing06,
            paddingTop: tokens.Spacing05,
            paddingBottom: tokens.Spacing05,
            position: 'sticky',
            bottom: 0,
            left: 0,
            right: 0,
        },
        controlContainer: {
            span: {
                marginBottom: 0,
                marginRight: tokens.Spacing06,
            },
        },
        lighter: {
            color: tokens.TextLight500,
        },
        rightStack: {
            spacing: tokens.Spacing03,
        },
        arrows: {
            spacing: tokens.Spacing04,
        },
        chevron: {
            width: '32px',
            cursor: 'pointer',
            _focus: {
                svg: {
                    shadow: 'none',
                    boxShadow: 'none',
                },
            },
            _focusVisible: {
                svg: {
                    borderColor: tokens.BorderFocus,
                    borderWidth: tokens.BorderWidth02,
                    shadow: 'none',
                },
            },
        },
        'chevron--disabled': {
            width: '32px',
            cursor: 'normal',
        },
    };
    const onPaginationPress = (action) => (e) => {
        if ((e.key === ' ' || e.key === 'Enter') &&
            (meta.has_next || meta.has_prev)) {
            e.preventDefault();
            if (action !== undefined) {
                action();
            }
            return;
        }
        return false;
    };
    const hasFromTo = meta.from && meta.to;
    const fromToText = !hasFromTo ? 0 : `${meta.from}-${meta.to}`;
    const fromToStyle = !hasFromTo ? styles.lighter : undefined;
    return (React.createElement(Flex, { sx: styles.container, "data-testid": "pagination" },
        React.createElement(Flex, { sx: styles.controlContainer },
            React.createElement(HStack, { spacing: styles.rightStack.spacing },
                React.createElement(RenderIf, { condition: isFetching },
                    React.createElement(Spinner, { color: tokens.CanvasPrimary, marginRight: tokens.Spacing04, size: "sm" })),
                React.createElement(Text, { sx: fromToStyle, "data-testid": "pagination__from_to_text", as: "span" },
                    fromToText,
                    ' ',
                    React.createElement(Text, { as: "span", sx: styles.lighter },
                        localise('OF'),
                        " ",
                        meta.total))),
            React.createElement(HStack, { spacing: styles.arrows.spacing },
                React.createElement(Box, { "data-testid": "pagination_chevron_prev", sx: !meta.has_prev ? styles['chevron--disabled'] : styles.chevron, onClick: meta.has_prev ? meta.onPrev : undefined, onKeyDown: onPaginationPress(meta.onPrev), tabIndex: meta.has_prev ? 0 : -1, "aria-disabled": !meta.has_prev || isFetching, "aria-label": localise('GO_TO_PREVIOUS_PAGE'), role: "button" },
                    React.createElement(Chevron, { disabled: !meta.has_prev || isFetching, direction: ChevronDirection.LEFT })),
                React.createElement(Box, { "data-testid": "pagination_chevron_next", sx: !meta.has_next ? styles['chevron--disabled'] : styles.chevron, onClick: meta.has_next ? meta.onNext : undefined, onKeyDown: onPaginationPress(meta.onNext), tabIndex: meta.has_next ? 0 : -1, "aria-disabled": !meta.has_next || isFetching, "aria-label": localise('GO_TO_NEXT_PAGE'), role: "button" },
                    React.createElement(Chevron, { disabled: !meta.has_next || isFetching, direction: ChevronDirection.RIGHT }))))));
};
export default Pagination;
